export const enUS: { [key: string]: any } = {
    'layout.menu.link.report': "Reports",
    
    'report.container.breadcrumb.item.resources':'Signal',
    'report.container.drawer.title': "Reports",

    'header.span.welcome':'Welcome',
    'profile.button.logout':'Logout',

    'exception.message.404.title':'Page Not Found',
    'exception.message.404.subtitle':'Entered a URL that does not exist on this site',
    'exception.message.400.title':'Bad Request',
    'exception.message.400.subtitle':'The browser sent a request that the server could not understand',
    'exception.message.403.title':'Access Denied',
    'exception.message.403.subtitle':'Sorry, you are not authorized to access this page',
    'exception.message.500.title':'Internal Server Error',
    'exception.message.500.subtitle':'Something happened in our systems. Please try again if the problem persists communicate with us with the following ticket number',
    'exception.message.default.thank':'Thank you',
    
    'share.link.copy.message':'Link copied to clipboard!',

    'empty.description':'No data found.',

    'dataset.container.table.name':'Name',
    'dataset.container.table.size':'Size',
    'dataset.container.table.createdOn':'Created On',
    'dataset.container.table.lastModified':'Last Modified',

    'dataset.container.input.search':'Type your text here',
    'dataset.container.button.loadmore':'Load more',

};